import { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import axios from 'axios';
import API_URL from '../utils/apiUrl';

const LanguageContext = createContext({ lang: 'en' });

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const { siteId } = useAuth();
  // Build-time locale wins (talksiteNO ships with REACT_APP_LANG=no).
  const forced = process.env.REACT_APP_LANG;
  const [lang, setLang] = useState(forced || 'en');

  useEffect(() => {
    if (forced || !siteId) return;
    axios.get(`${API_URL}/api/site-language/${siteId}`)
      .then(res => setLang(res.data.language || 'en'))
      .catch(() => {});
  }, [siteId, forced]);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};
